module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/slideshow-singlepage-1-c833fb4a5a849fbde3f49cb6985899df.jpg";